"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataAttachmentV3Service", {
    enumerable: true,
    get: function() {
        return DataAttachmentV3Service;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _stream = require("stream");
const _common = require("@nestjs/common");
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _nanoid = require("nanoid");
const _nocodbsdk = require("nocodb-sdk");
const _slash = /*#__PURE__*/ _interop_require_default(require("slash"));
const _requestfilteringagent = require("request-filtering-agent");
const _stringHelpers = require("src/helpers/stringHelpers");
const _constants = require("~/constants");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _dbHelpers = require("~/helpers/dbHelpers");
const _ncError = require("~/helpers/ncError");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _Jobs = require("~/interface/Jobs");
const _models = require("~/models");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _datav3service = require("~/services/v3/data-v3.service");
const _utils = require("~/utils");
const _attachmentUtils = require("~/utils/attachmentUtils");
const _globals = require("~/utils/globals");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
// ref: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html - extended with some more characters
const normalizeFilename = (filename)=>{
    return filename.replace(/[\\/:*?"<>'`#|%~{}[\]^]/g, '_');
};
const mb = 1024 * 1024;
let DataAttachmentV3Service = class DataAttachmentV3Service {
    async handleUrlUploadCellUpdate(param) {
        const { context, modelId, column, recordId, scope, req, attachments } = param;
        const baseModel = await (0, _dbHelpers.getBaseModelSqlFromModelId)({
            context: context,
            modelId: modelId
        });
        await baseModel.model.getColumns(context);
        const processedAttachments = [];
        const generateThumbnailAttachments = [];
        for (const attachment of attachments){
            try {
                if (attachment.id && (!('status' in attachment) || 'status' in attachment && attachment.status !== 'uploading')) {
                    processedAttachments.push(attachment);
                } else if (attachment.url && 'status' in attachment && attachment.status === 'uploading') {
                    var _downloadedAttachment_url;
                    // If attachment has URL, download and process it
                    const downloadedAttachment = await this.downloadAndStoreAttachment(context, {
                        filePath: attachment,
                        url: attachment.url,
                        scope
                    });
                    // update fileSize, url due to fileName, fileSize etc
                    await _models.FileReference.updateById(context, attachment.id, {
                        file_url: (_downloadedAttachment_url = downloadedAttachment.url) != null ? _downloadedAttachment_url : downloadedAttachment.path,
                        file_size: downloadedAttachment.fileSize,
                        deleted: false
                    });
                    const processedAttachment = {
                        id: attachment.id,
                        url: (0, _nocodbsdk.ncIsNull)(downloadedAttachment.url) ? undefined : downloadedAttachment.url,
                        path: (0, _nocodbsdk.ncIsNull)(downloadedAttachment.url) ? downloadedAttachment.path : undefined,
                        title: downloadedAttachment.filename,
                        mimetype: downloadedAttachment.mimeType,
                        size: downloadedAttachment.fileSize,
                        signedUrl: undefined
                    };
                    processedAttachments.push(processedAttachment);
                    if ((0, _attachmentUtils.supportsThumbnails)({
                        mimetype: downloadedAttachment.mimeType,
                        size: downloadedAttachment.fileSize
                    })) {
                        generateThumbnailAttachments.push(processedAttachment);
                    }
                }
            } catch (error) {
                console.error(`Failed to process attachment:`, error);
            }
        }
        // direct update to prevent prepare noco data again
        await baseModel.dbDriver(baseModel.getTnPath(baseModel.model)).update({
            [column.column_name]: JSON.stringify(processedAttachments)
        }).where(await (0, _dbHelpers._wherePk)(baseModel.model.primaryKeys, recordId, true));
        if (generateThumbnailAttachments.length > 0) {
            await this.jobsService.add(_Jobs.JobTypes.ThumbnailGenerator, {
                context: {
                    base_id: _globals.RootScopes.ROOT,
                    workspace_id: _globals.RootScopes.ROOT
                },
                attachments: generateThumbnailAttachments,
                scope
            });
            for (const processedAttachment of generateThumbnailAttachments){
                if (processedAttachment.url) {
                    processedAttachment.signedUrl = await _models.PresignedUrl.getSignedUrl({
                        pathOrUrl: processedAttachment.url,
                        filename: processedAttachment.title,
                        expireSeconds: 3 * 60 * 60,
                        preview: true,
                        mimetype: processedAttachment.mimetype
                    });
                }
            }
        }
        await _models.Audit.insert(await (0, _utils.generateAuditV1Payload)(_nocodbsdk.AuditV1OperationTypes.DATA_UPDATE, {
            context: context,
            row_id: recordId,
            fk_model_id: baseModel.model.id,
            fk_workspace_id: context.workspace_id,
            base_id: context.base_id,
            source_id: baseModel.model.source_id,
            details: {
                table_title: baseModel.model.title,
                column_meta: (0, _utils.extractColsMetaForAudit)([
                    column
                ], {
                    [column.title]: processedAttachments
                }),
                data: {
                    [column.title]: processedAttachments
                },
                old_data: {
                    [column.title]: attachments.filter((attr)=>!('status' in attr) || attr.status !== 'uploading')
                }
            },
            req: req != null ? req : {
                user: context.user
            }
        }));
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.DATA_EVENT,
            payload: {
                id: recordId,
                action: 'update',
                payload: await baseModel.readByPk(recordId, false)
            },
            scopes: [
                modelId
            ]
        }, context.socket_id);
    }
    async appendBase64AttachmentToCellData(param) {
        const { context, modelId, columnId, recordId, scope, attachment, req } = param;
        // Calculate file size from base64 value
        const fileSize = (0, _stringHelpers.getBase64FileSize)(attachment.file);
        if (fileSize > _constants.NC_ATTACHMENT_FIELD_SIZE) {
            _ncError.NcError.get(context).invalidRequestBody(`Attachment is larger than maximum allowed size at ${(_constants.NC_ATTACHMENT_FIELD_SIZE / mb).toFixed(2)} mb`);
        }
        const baseModel = await (0, _dbHelpers.getBaseModelSqlFromModelId)({
            context: context,
            modelId: modelId
        });
        await baseModel.model.getColumns(context);
        const column = baseModel.model.columns.find((col)=>col.id === columnId);
        // Check if column exists in model
        if (!column) {
            _ncError.NcError.get(context).fieldNotFound(columnId);
        }
        // Get the row data
        const rowData = await baseModel.dbDriver(baseModel.getTnPath(baseModel.model)).where(await (0, _dbHelpers._wherePk)(baseModel.model.primaryKeys, recordId, true)).first();
        if (!rowData) {
            _ncError.NcError.get(context).recordNotFound(recordId);
        }
        if (!attachment.contentType || !attachment.file || !attachment.filename) {
            _ncError.NcError.get(context).invalidRequestBody(`Field contentType, file and filename is required`);
        }
        // Update the cell field using baseModel.dbDriver directly
        const currentAttachments = rowData[column.column_name] ? JSON.parse(rowData[column.column_name]) : [];
        await (0, _attachmentHelpers.validateNumberOfFilesInCell)(context, currentAttachments.length + 1, column);
        const processedAttachments = [];
        const generateThumbnailAttachments = [];
        try {
            var _ref;
            var _context_user;
            const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
            const mimeType = attachment.contentType.split(';')[0].trim();
            let filename = attachment.filename;
            filename = scope ? `${normalizeFilename(_path.default.parse(filename).name)}${_path.default.extname(filename)}` : `${normalizeFilename(_path.default.parse(filename).name)}_${(0, _nanoid.nanoid)(5)}${_path.default.extname(filename)}`;
            const filePath = _path.default.join(...[
                context.workspace_id,
                context.base_id,
                modelId,
                column.id
            ].filter((k)=>k));
            const destPath = _path.default.join('nc', scope != null ? scope : 'uploads', filePath);
            const resultAttachmentUrl = await storageAdapter.fileCreateByStream((0, _slash.default)(_path.default.join(destPath, filename)), new _stream.PassThrough().end(attachment.file, 'base64'));
            const attachmentId = await _models.FileReference.insert(context, {
                storage: storageAdapter.name,
                file_url: resultAttachmentUrl != null ? resultAttachmentUrl : _path.default.join('download', filePath, filename),
                file_size: fileSize,
                fk_user_id: (_ref = context == null ? void 0 : (_context_user = context.user) == null ? void 0 : _context_user.id) != null ? _ref : 'anonymous',
                source_id: baseModel.model.source_id,
                fk_model_id: modelId,
                fk_column_id: column.id,
                is_external: !(await baseModel.getSource()).isMeta()
            });
            const processedAttachment = {
                id: attachmentId,
                url: (0, _nocodbsdk.ncIsNull)(resultAttachmentUrl) ? undefined : resultAttachmentUrl,
                path: (0, _nocodbsdk.ncIsNull)(resultAttachmentUrl) ? _path.default.join('download', filePath, filename) : undefined,
                title: filename,
                mimetype: mimeType,
                size: fileSize
            };
            processedAttachments.push(processedAttachment);
            if ((0, _attachmentUtils.supportsThumbnails)({
                mimetype: mimeType,
                size: fileSize
            })) {
                generateThumbnailAttachments.push(processedAttachment);
            }
        } catch (error) {
            var _error_constructor;
            this.logger.error(`${error == null ? void 0 : (_error_constructor = error.constructor) == null ? void 0 : _error_constructor.name}: ${error == null ? void 0 : error.message}`);
            _ncError.NcError.get(context).unprocessableEntity(`Failed to process base64 attachment`);
        }
        const updatedAttachments = [
            ...currentAttachments,
            ...processedAttachments
        ];
        await baseModel.dbDriver(baseModel.getTnPath(baseModel.model)).update({
            [column.column_name]: JSON.stringify(updatedAttachments)
        }).where((0, _dbHelpers._wherePk)(baseModel.model.primaryKeys, recordId, true));
        if (generateThumbnailAttachments.length > 0) {
            await this.jobsService.add(_Jobs.JobTypes.ThumbnailGenerator, {
                context: {
                    base_id: _globals.RootScopes.ROOT,
                    workspace_id: _globals.RootScopes.ROOT
                },
                attachments: generateThumbnailAttachments,
                scope
            });
        }
        await baseModel.updateLastModified({
            rowIds: [
                recordId
            ],
            cookie: {
                user: context.user
            },
            baseModel,
            knex: baseModel.dbDriver,
            model: baseModel.model,
            updatedColIds: [
                column.id
            ]
        });
        await _models.Audit.insert(await (0, _utils.generateAuditV1Payload)(_nocodbsdk.AuditV1OperationTypes.DATA_UPDATE, {
            context: context,
            row_id: recordId,
            fk_model_id: baseModel.model.id,
            fk_workspace_id: context.workspace_id,
            base_id: context.base_id,
            source_id: baseModel.model.source_id,
            details: {
                table_title: baseModel.model.title,
                column_meta: (0, _utils.extractColsMetaForAudit)([
                    column
                ], {
                    [column.title]: updatedAttachments
                }),
                data: {
                    [column.title]: updatedAttachments
                },
                old_data: {
                    [column.title]: currentAttachments
                }
            },
            req: req != null ? req : {
                user: context.user
            }
        }));
        return await this.dataV3Service.dataRead(context, {
            modelId,
            query: '',
            req: {
                context,
                user: context.user
            },
            rowId: recordId
        });
    }
    async downloadAndStoreAttachment(context, { url, filePath, scope }) {
        // Configure axios for download
        const response = await (0, _axios.default)({
            method: 'GET',
            url: url,
            responseType: 'stream',
            maxRedirects: _constants.NC_ATTACHMENT_URL_MAX_REDIRECT,
            maxContentLength: _constants.NC_ATTACHMENT_FIELD_SIZE,
            httpAgent: (0, _requestfilteringagent.useAgent)(url),
            httpsAgent: (0, _requestfilteringagent.useAgent)(url)
        });
        // Extract file information from response headers
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const contentLength = response.headers['content-length'];
        const contentDisposition = response.headers['content-disposition'];
        const passthrough = new _stream.PassThrough(); // Track size via the PassThrough stream
        let totalBytes = 0;
        if (!contentLength) {
            passthrough.on('data', (chunk)=>{
                totalBytes += chunk.length;
            });
        }
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        const mimeType = contentType.split(';')[0].trim();
        // Extract filename from URL or content-disposition header
        let filename;
        let originalFileName;
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
                originalFileName = filenameMatch[1].replace(/['"]/g, '');
                filename = scope ? `${normalizeFilename(_path.default.parse(originalFileName).name)}${_path.default.extname(originalFileName)}` : `${normalizeFilename(_path.default.parse(originalFileName).name)}_${(0, _nanoid.nanoid)(5)}${_path.default.extname(originalFileName)}`;
            }
        }
        const filePathConstructed = filename ? (0, _attachmentHelpers.constructFilePath)(context, _extends({}, filePath, {
            fileName: filename,
            originalFileName
        })) : filePath;
        const resultAttachmentUrl = await storageAdapter.fileCreateByStream(filePathConstructed.storageDest, response.data.pipe(passthrough));
        const fileSize = contentLength ? Number(contentLength) : totalBytes;
        return {
            storageName: storageAdapter.name,
            url: resultAttachmentUrl,
            path: _path.default.join('download', filePathConstructed.filePath, filePathConstructed.fileName),
            filename: filePathConstructed.originalFileName,
            mimeType,
            fileSize
        };
    }
    constructor(jobsService, dataV3Service){
        this.jobsService = jobsService;
        this.dataV3Service = dataV3Service;
        this.logger = new _common.Logger(DataAttachmentV3Service.name);
    }
};
DataAttachmentV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)((0, _common.forwardRef)(()=>'JobsService'))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _datav3service.DataV3Service === "undefined" ? Object : _datav3service.DataV3Service
    ])
], DataAttachmentV3Service);
